export default __webpack_public_path__ + "static/media/bg5.f9cf0b49.jpg";